import Vue from 'vue'
import VueRouter from 'vue-router'
import cart from '@/views/user/cart'
import ordDet from '@/views/user/details'
import orders from '@/views/user/orders'
import pass from '@/views/user/pass'
import coupon from '@/views/user/coupon'
import inter from '@/views/user/inter'
import exc from '@/views/user/exc'
import gift from '@/views/user/gift'
import addAdr from '@/views/user/addAdr'
import Users from '@/views/user/index'
import User from '@/views/user/user'
import kin from '@/views/login/kin'
import Infos from '@/views/user/infos'
import sub from '@/views/user/sub'
import comment from '@/views/user/comment'
Vue.use(VueRouter)

const router = new VueRouter({
    routes: [{
        path: '/',
        redirect: '/user/orders'
    },{
        path: '/user',
        component: Users,
		redirect: '/user/user',
		children: [
		
			{
			    path: '/user/addAdr',
			    component: addAdr,
			},
			{
			    path: '/user/user',
			    component: User,
			},{
                path: '/user/cart',
                component: cart,
            },{
                path: '/user/orders',
                component: orders
            },{
                path: '/user/details',
                component: ordDet
            },
			{
			    path: '/user/coupon',
			    component: coupon
			},{
			    path: '/user/pass',
			    component: pass
			},{
			    path: '/user/inter',
			    component: inter
			},{
			    path: '/user/exc',
			    component: exc
			},{
			    path: '/user/gift',
			    component: gift
			},{
			    path: '/user/sub',
			    component: sub
			},{
			    path: '/user/comment',
			    component: comment
			}
			
			
		]
    },{
        path: '/kin',
        component: kin,
    },{
        path: '/infos',
        component: Infos
    }]
})

export default router